<template>
  <div class="products">
    <Breadcrumb :items="breadcrumb" :key="category.categoryId" />

    <v-container>
      <ProductListGrid
        v-bind:parentCategoryId="category.categoryId"
        :key="category.categoryId"
        :category="category"
        @productsCount="updateCount"
        position="category_nofilters"
        :hidePromoFilter="true"
        :hideFacetsFilter="true"
        hideFilterString="Categorie,Fornitore"
      >
        <template #category-title>
          <category-title
            class="mt-2 mt-sm-0"
            v-if="category"
            :category="category"
            :showSub="true"
          />
        </template>
        <template #category-block-position-1>
          <category-block
            :target="category"
            position="position1"
            class="category-block category-block-1"
            :container="false"
          />
        </template>
        <template #category-block-position-3>
          <category-block
            :target="category"
            position="position3"
            class="category-block category-block-3"
            :container="false"
          />
        </template>
        <template #category-block-position-4>
          <category-block
            :target="category"
            position="position4"
            class="category-block category-block-4"
            :container="false"
          />
        </template>
      </ProductListGrid>
    </v-container>
    <div class="grey lighten-3 product-slider-wrapper">
      <category-block
        :target="category"
        position="position2"
        class="category-block category-block-2"
      />
    </div>
    <v-container v-if="footerText">
      <div v-html="footerText" class="footer-text" />
    </v-container>
  </div>
</template>
<style lang="scss">
.products {
  .category-title {
    margin-top: -17px;
  }
}

.footer-text {
  background-color: transparent !important;
  h2 {
    color: var(--v-primary-lighten1) !important;
    font-weight: 400;
    font-size: 31px;
    margin-top: 14px;
    margin-bottom: 7px;
  }
}
</style>
<script>
import ProductListGrid from "@/components/product/ProductListGrid";

import Breadcrumb from "@/components/navigation/Breadcrumb";
import categoryMixins from "~/mixins/category";

export default {
  name: "CategoryNofilters",
  mixins: [categoryMixins],
  components: {
    ProductListGrid,
    Breadcrumb
  },
  data() {
    return { count: -1 };
  },
  computed: {
    footerText() {
      return this.$ebsn.meta(
        this.category,
        "metaData.category_info.FOOTER_TEXT",
        null
      );
    }
  },
  methods: {
    updateCount(count) {
      this.count = count;
    }
  },
  metaInfo() {
    let text = this.category.name;
    if (this.breadcrumb.length > 0) {
      text = this.breadcrumb[this.breadcrumb.length - 2].text;
    }
    return {
      title: this.$ebsn.meta(
        this.category,
        "metaData.category_seo.SEO_TITLE",
        this.category ? this.category.name : ""
      ),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$ebsn.meta(
            this.category,
            "metaData.category_seo.SEO_DESCRIPTION",
            this.$t("meta.category.secondAndThirdLevel.description", [
              this.category.name,
              text
            ])
          )
        }
      ]
    };
  }
};
</script>
